import React, { Component } from 'react';
import PrimaryButtonGE from '../../Components/PrimaryButtonGE/PrimaryButtonGE';
import { withTranslation } from 'react-i18next';
import ModalGE from '../../Components/ModalGE/ModalGE';
import './styles.scss';
import PulseLoader from 'react-spinners/PulseLoader';

const override = `
  display: block;
  margin: 0 auto;
  border-color: red;
  text-align: center;
`;

class DownloadInitialize extends Component {

    getControls = (showRetry) => {
        const { t, closeSubmittingModal, retryDownload } = this.props;
    
        return (
            <>
                {showRetry ? (
                    <div className="download-controls-container">
                        <PrimaryButtonGE
                            filled={false}
                            className="cancel-download-button"
                            text={t('cancel')}
                            onClick={closeSubmittingModal}
                        />
                        <PrimaryButtonGE
                            text={t('retry')}
                            className="send-download-button"
                            onClick={retryDownload}
                        />
                    </div>
                ) : (
                    <div className="close-download-btn">
                        <PrimaryButtonGE
                            text={t('closeText')}
                            onClick={closeSubmittingModal}
                        />
                    </div>
                )}
            </>
        );
    };
    

    render() {
        let { downloadStarted, downloadInitializing, downloadError } = this.props;
        const { t } = this.props;

        return (
            <div className="submit-download-wrapper">
                <ModalGE
                    onDismiss={this.props.closeSubmittingModal.bind(this)} showCrossButton={false}>
                    <div className="support-download">
                        {downloadInitializing &&
                            <div className="download-submitting">
                                <PulseLoader color={'#ffffff'} css={override} />
                            </div>
                        }
                        {downloadStarted &&
                            <div className="download-submitted">
                                <p className="download-text">{t('downloadStartedText')}</p>
                                <div className="close-download-btn">
                                    <PrimaryButtonGE
                                        text={t('closeText')}
                                        onClick={this.props.closeSubmittingModal.bind(this)}
                                    />
                                </div>
                            </div>
                        }
                        {downloadError &&
                            <div className="download-submitted">
                                <p className="download-text">{t(downloadError)}</p>
                                {this.getControls(downloadError === 'downloadErrorText1')}
                            </div>
                        }
                    </div>
                </ModalGE>
            </div>
        );
    }
}
export default withTranslation()(DownloadInitialize);
